import { ExecSyncOptionsWithBufferEncoding } from "child_process";

export class Banner {
  enabled: boolean;
  message: string;
  eTag: string;
  partitionKey: ExecSyncOptionsWithBufferEncoding;
  rowKey: string;
  timestamp:  string;
}


// WEBPACK FOOTER //
// ./src/app/models/banner.ts